import React from 'react'
import { Field, ErrorMessage, FieldArray } from 'formik'
import { Row, Col, Card, CardBody, Label } from "reactstrap";
import toast from "react-hot-toast";

const AirGeneralCargoType = ({ quotesForm, volume, totalWeight, addContainerValidationSet, validateAddContainer }) => {
    const handleAddPackage = (arrayHelpers) => {
        validateAddContainer(true)
        addContainerValidationSet &&
            arrayHelpers.insert(quotesForm.values.container.length + 1,
                {
                    // weightPerCargo: '',
                    packageType: '',
                    length: '',
                    width: '',
                    height: '',
                    weight: '',
                    noOfContainer: ''
                })
    }

    return (
        <>
            <Row className='justify-content-center'>
                <Col className='cargoType-component'>

                    <div className='form-group'>
                        <FieldArray name='container' render={
                            (arrayHelpers) => {
                                return <div>
                                    {quotesForm.values.container.map((details, index) => (
                                        <div className='mt-2 position-relative' key={index}>
                                            <div className='close-icon float-end'>
                                                <button className='btn btn-danger close-btn' hidden={quotesForm.values.container.length > 1 ? false : true} type='button' onClick={() => arrayHelpers.remove(index)}>X</button>
                                            </div>
                                            <div className='card' style={{ padding: 5 }}>
                                                <div className='card-body'>
                                                    <Row className='mb-4 '>
                                                        <Col md={4} className='form-group'>
                                                            <div className='container-item'>

                                                                <Label>Package type<span>*</span></Label>
                                                                <Field
                                                                    type='text'
                                                                    className='form-control required-field'
                                                                    name={`container.${index}.packageType`}
                                                                    id={`container.${index}.packageType`}
                                                                />
                                                                <ErrorMessage
                                                                    component='span'
                                                                    className='field_error'
                                                                    name={`container.${index}.packageType`}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={2} className='form-group'>
                                                            <div className='container-item'>
                                                                <Label>Length(cm)<span>*</span></Label>
                                                                <Field
                                                                    onWheel={(e) => e.target.blur()}
                                                                    type='number'
                                                                    className='form-control required-field'
                                                                    name={`container.${index}.length`}
                                                                    id={`container.${index}.length`}
                                                                />
                                                                <ErrorMessage
                                                                    component='span'
                                                                    className='field_error'
                                                                    name={`container.${index}.length`}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={2} className='form-group'>
                                                            <div className='container-item'>
                                                                <Label>Width(cm)<span>*</span></Label>
                                                                <Field
                                                                    onWheel={(e) => e.target.blur()}
                                                                    type='number'
                                                                    className='form-control required-field'
                                                                    name={`container.${index}.width`}
                                                                    id={`container.${index}.width`}
                                                                />
                                                                <ErrorMessage
                                                                    component='span'
                                                                    className='field_error'
                                                                    name={`container.${index}.width`}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={2} className='form-group'>
                                                            <div className='container-item'>
                                                                <Label>Height(cm)<span>*</span></Label>
                                                                <Field
                                                                    onWheel={(e) => e.target.blur()}
                                                                    type='number'
                                                                    className='form-control required-field'
                                                                    name={`container.${index}.height`}
                                                                    id={`container.${index}.height`}
                                                                />
                                                                <ErrorMessage
                                                                    component='span'
                                                                    className='field_error'
                                                                    name={`container.${index}.height`}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md={2} className='form-group'>
                                                            <div className='container-item'>
                                                                <Label>Weight(kg)<span>*</span></Label>
                                                                <Field
                                                                    onWheel={(e) => e.target.blur()}
                                                                    type='number'
                                                                    className='form-control required-field'
                                                                    name={`container.${index}.weight`}
                                                                    id={`container.${index}.weight`}
                                                                />
                                                                <ErrorMessage
                                                                    component='span'
                                                                    className='field_error'
                                                                    name={`container.${index}.weight`}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    {/* <div className='form-group mb-3'>
                                                                <Row className="mb-4 container-item align-items-baseline">
                                                                    <Col sm={4}>
                                                                        <Label htmlFor={`container.${index}.weightPerCargo`}>Gross weight(kg)<span> *</span></Label>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <Field
                                                                            type='text'
                                                                            className='form-control required-field'
                                                                            name={`container.${index}.weightPerCargo`}
                                                                            id={`container.${index}.weightPerCargo`}
                                                                        />
                                                                    </Col>
                                                                    <ErrorMessage
                                                                        component='span'
                                                                        className='field_error'
                                                                        name={`container.${index}.weightPerCargo`}
                                                                    />
                                                                </Row>
                                                            </div> */}
                                                    <Row className='justify-content-sm-between'>
                                                        <Col md="4" className='form-group '>
                                                            <div className="container-item align-items-baseline">
                                                                <Col>
                                                                    <Label>No of package<span>*</span></Label>
                                                                </Col>
                                                                <Col>
                                                                    <Field
                                                                        onWheel={(e) => e.target.blur()}
                                                                        type='number'
                                                                        className='form-control required-field'
                                                                        name={`container.${index}.noOfContainer`}
                                                                        id={`container.${index}.noOfContainer`}
                                                                    />
                                                                </Col>
                                                                <ErrorMessage
                                                                    component='span'
                                                                    className='field_error'
                                                                    name={`container.${index}.noOfContainer`}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col md="4" className='value-col'>
                                                            <div className='form-group value-card'>
                                                                <Row className="container-item align-items-center">
                                                                    <Col sm={6} className="pe-0">
                                                                        <p className='m-0 mb-2'>Package volume </p>
                                                                        <span className='m-0 value'>  {
                                                                            (
                                                                                quotesForm.values.container[index].length &&
                                                                                quotesForm.values.container[index].width &&
                                                                                quotesForm.values.container[index].height
                                                                            ) ?
                                                                                (
                                                                                    quotesForm.values.container[index].length * quotesForm.values.container[index].width * quotesForm.values.container[index].height * 1000
                                                                                ) : 0
                                                                        } M³</span>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <p className='m-0 mb-2'>Package weight </p>
                                                                        <span className='m-0 value'>  {
                                                                            quotesForm.values.container[index].weight ?
                                                                                ((quotesForm.values.container[index].weight) *
                                                                                    ((quotesForm.values.container[index].noOfContainer) ? quotesForm.values.container[index].noOfContainer : 1)).toFixed(2)
                                                                                :
                                                                                (0 * ((quotesForm.values.container[index].noOfContainer) ? quotesForm.values.container[index].noOfContainer : 1)).toFixed(2)
                                                                        } KG</span>
                                                                    </Col>
                                                                </Row>
                                                            </div></Col>
                                                    </Row>

                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className='card border-0 shadow-none'>
                                        <div className='card-body'>
                                            <Row className='justify-content-sm-between '>
                                                <Col md="4">
                                                    <Row className='mb-4  align-items-center  value-card'>
                                                        <Col sm={6}>
                                                            <p className='m-0 mb-2'>Total volume</p>
                                                            <span className='m-0 value'>{(volume > 0) ? volume : 0} M³</span>
                                                        </Col>
                                                        <Col sm={6}>
                                                            <p className='m-0 mb-2'>Total weight</p>
                                                            <span className='m-0 value'>  {(totalWeight > 0) ? totalWeight.toFixed(2) : 0} KG</span>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col md="3">
                                                    <div className='form-group float-end mt-2'>
                                                        <button type={'button'} className='primary-button'
                                                            onClick={() => handleAddPackage(arrayHelpers)}>Add Package</button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            }
                        }>
                        </FieldArray>
                    </div>

                </Col>
            </Row>
        </>
    )
}

export default AirGeneralCargoType
